import React from 'react';
import OutlookCalendarIcon from "../../../assets/icons/ms-outlook.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import FeatureLock from "../../../components/FeatureLock/FeatureLock";
import { FEATURE_IDS } from "../../../constants/featureAccess";


const OutlookCalendar = () => {
    return (
        <Col md="6" xxl="3" xl="4">
            <FeatureLock featureId={FEATURE_IDS.CALENDAR_INTEGRATIONS}>
                <Link to="/admin/calendar-integration" className="int-col">
                <div className="img">
                    <img
                    src={OutlookCalendarIcon}
                    alt="Outlook Calendar"
                    />
                </div>
                <div className="text">
                    <h3>Outlook Calendar</h3>
                    <p>
                    Manage your schedule with Outlook Calendar — organize meetings, events, and reminders seamlessly.
                    </p>
                </div>
                </Link>
            </FeatureLock>
        </Col>
    );
}

export default OutlookCalendar;
